import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { useAuth } from '@/auth/auth.composable';
import Maska from 'maska';
import VueRecaptcha from "vue3-recaptcha-v2";
import { useRecaptchaHelpers } from '@/shared/recaptcha-helpers.composable';

const recaptchaSiteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
const hasRecaptchaSiteKey = !!recaptchaSiteKey;

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(Maska)
if (hasRecaptchaSiteKey) {
  app.use(VueRecaptcha, { siteKey: recaptchaSiteKey })
}

const { setEnableRecaptcha } = useRecaptchaHelpers();
setEnableRecaptcha(hasRecaptchaSiteKey);

const { configureAuth } = useAuth();
configureAuth();

router.isReady().then(() => {
  app.mount('#app');
});
